module.exports = "/images/vendor/flag-icon-css/flags/4x3/bb.svg?9873885f352c415ad25c32ecf69e5cd3";